import { CompanyInsertLink } from './CompanyInsertLink';

export * from "./hooks/useInsertLink"

export default CompanyInsertLink;